import { mapActions, mapGetters } from 'vuex'
import helpers from '@/com/libs/helpers';
const core = {
  data () {
    return {
      imageRoot: process.env.VUE_APP_IMAGE_ROOT,
      domain: window.location.hostname,
      appDomain: null
    }
  },
  computed: {
    ...mapGetters({
      cid: "appStore/cid",
      user: "appStore/user",
      branding: "appStore/branding",
      loaded: "appStore/loaded"
    })
  },
  methods: {
    ...mapActions({
      setCustId: "appStore/setCustId",
      setUser: "appStore/setUser",
      setBrand: "appStore/setBrand",
      setLoaded: "appStore/setLoaded"
    }),
    step () {
      alert("loaded");
    },
    log (msg) {
      helpers.logger(msg)
    }
  }
}

export default core